// Barrel for the offline-recording Tauri bridge.
// Scaffolded under APP-6185; identity read added under APP-6186;
// connectivity adapter added under APP-6259.
export {
  OFFLINE_AUTOMATIC_REDRIVE_READY_EVENT,
  OFFLINE_CONNECTIVITY_CHANGED_EVENT,
  connectivityBridge,
  listenOfflineAutomaticRedriveReady,
  listenOfflineConnectivityChanged,
  type OfflineAutomaticRedriveReadyEvent,
  type OfflineConnectivityChangedEvent,
} from './connectivity';
export { cachedIdentityBridge, type CachedIdentity } from './identity';
export {
  OFFLINE_SERVER_DELETE_ENQUEUED_EVENT,
  OFFLINE_SERVER_DELETE_SETTLED_EVENT,
  offlineRecordingBridge,
  type CreateOfflineRecordingArgs,
  type OfflineRecordingItem,
  type OfflineSalvageCauseCount,
  type OfflineSalvageRunReport,
  type OfflineServerDeleteEnqueuedEvent,
  type OfflineServerDeleteSettledEvent,
  type OfflineStorageStatus,
} from './recording';
export { offlineSyncBridge } from './sync';
